module.exports = __webpack_public_path__ + "img/logo.ac3e3f2a.png";